module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/lb-940cc75a55e4b18f510a404301dd6e61.svg";